/* nm-pages-motion.js · catálogo / PDP: Lenis + ScrollTrigger. Pin real en desktop; no aborta por reduced-motion (solo suaviza). */
(function () {
  'use strict';
  function boot() {
    if (!window.gsap || !window.ScrollTrigger) return;
    var root = document.documentElement;
    var reduce = root.classList.contains('rm');
    var $ = function (s, r) { return (r || document).querySelector(s); };
    var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
    var isMobile = function () { return innerWidth <= 820; };
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.config({ ignoreMobileResize: true });

    var lenis = null;
    if (!isMobile() && !reduce && matchMedia('(pointer:fine)').matches && window.Lenis) {
      lenis = new Lenis({
        duration: 1.35,
        smoothWheel: true,
        wheelMultiplier: 0.85,
        touchMultiplier: 1.2,
        easing: function (t) { return 1 - Math.pow(1 - t, 4); }
      });
      window.lenis = lenis;
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
      gsap.ticker.lagSmoothing(0);
    }

    function splitWords(el) {
      if (!el || el.dataset.split) return;
      el.dataset.split = '1';
      el.setAttribute('aria-label', (el.textContent || '').replace(/\s+/g, ' ').trim());
      var walk = function (n) {
        [].slice.call(n.childNodes).forEach(function (c) {
          if (c.nodeType === 3) {
            var f = document.createDocumentFragment();
            c.textContent.split(/(\s+)/).forEach(function (t) {
              if (!t) return;
              if (/^\s+$/.test(t)) { f.appendChild(document.createTextNode(t)); return; }
              var w = document.createElement('span'); w.className = 'w'; w.setAttribute('aria-hidden', 'true');
              var i = document.createElement('span'); i.className = 'wi'; i.textContent = t; w.appendChild(i); f.appendChild(w);
            });
            c.replaceWith(f);
          } else if (c.nodeType === 1) walk(c);
        });
      };
      walk(el);
    }

    /* orbes */
    $$('.cine-orb').forEach(function (orb, i) {
      gsap.to(orb, {
        y: i % 2 ? 100 : -140,
        x: i % 2 ? -60 : 80,
        ease: 'none',
        scrollTrigger: {
          trigger: orb.closest('[data-cine]') || document.body,
          start: 'top top', end: 'bottom bottom', scrub: 1.4
        }
      });
    });

    /* -------- COLLECTION / SEARCH: grid editorial (sin pin horizontal) -------- */
    var coll = $('[data-cine="collection"],[data-cine="search"]');
    if (coll) {
      if (!reduce) {
        gsap.from('.ch-kicker, .ch-title, .ch-count, .ch-sort, .ch-search, .ch-tabs, .ed-kicker, .ed-title, .ed-sub, .ed-sort, .cine-kicker, .cine-title, .cine-sub, .cine-sort, .cine-search', {
          opacity: 0, y: 22, duration: 0.9, ease: 'power3.out', stagger: 0.06, delay: 0.08
        });
      }
      var cards = $$('.ed-grid .card, .cine-track .card, .coll-grid .card', coll);
      if (cards.length && !reduce) {
        gsap.set(cards, { clearProps: 'opacity,visibility' });
        cards.forEach(function (card, i) {
          gsap.from(card, {
            y: 28, opacity: 0, duration: 0.7, ease: 'expo.out',
            scrollTrigger: { trigger: card, start: 'top 92%', once: true },
            delay: Math.min(i * 0.03, 0.3)
          });
        });
      }
    }

    /* -------- PDP PIN REAL (desktop) -------- */
    var pdp = $('[data-cine="product"]');
    if (pdp) {
      $$('.pdp-title.split', pdp).forEach(splitWords);
      var tw = $$('.pdp-title .wi', pdp);
      if (tw.length && !reduce) {
        gsap.set(tw, { yPercent: 110 });
        gsap.to(tw, { yPercent: 0, duration: 1.05, ease: 'expo.out', stagger: 0.035, delay: 0.1 });
      }
      /* Entrada corta solo móvil; en desktop el pin define el estado hero */
      if (!reduce && isMobile()) {
        gsap.from('.cine-pdp-copy .fade, .cine-pdp-copy .pdp-form, .cine-pdp-copy .lg', {
          opacity: 0, y: 24, duration: 0.85, ease: 'power3.out', stagger: 0.06, delay: 0.3
        });
        gsap.from('.cine-pdp-media .pdp-main', {
          y: 36, scale: 0.94, duration: 1.1, ease: 'expo.out', delay: 0.12
        });
      }

      var scene = $('#cine-pdp-scene');
      if (scene && !isMobile()) {
        if (!$('.cine-pin-progress', scene)) {
          var bar = document.createElement('div');
          bar.className = 'cine-pin-progress'; bar.setAttribute('aria-hidden', 'true');
          bar.innerHTML = '<i></i>';
          scene.appendChild(bar);
        }
        /* Estado inicial cinematográfico (hero bottle) — se morphéa en 3 actos */
        gsap.set('.cine-pdp-media', { xPercent: 8, scale: 1.18, transformOrigin: '50% 45%' });
        gsap.set('.cine-pdp-media .pdp-main', { scale: 1.06, y: 10 });
        /* El bloque de compra (título, precio, botón) se ve nítido desde la carga; la escena solo lo desplaza */
        gsap.set('.cine-pdp-copy', { xPercent: 6, y: 16, opacity: 1, filter: 'none' });
        gsap.set('.cine-orb--p', { scale: 0.7, opacity: 0.55 });

        /*
          PELÍCULA PDP — pin ~1.5 vh (ajuste NM: antes 3.4, se sentía muy largo),
          3 actos inequívocos en video:
          A 0–0.35  botella grande / copy entra
          B 0.35–0.7 media se achica, keys aparecen, orbe explota
          C 0.7–1   bridge a descripción (slide up)
        */
        var pinTl = gsap.timeline({
          scrollTrigger: {
            trigger: scene,
            start: 'top top',
            end: function () { return '+=' + Math.round(innerHeight * 1.5); },
            scrub: 0.4,
            pin: true,
            pinSpacing: true,
            anticipatePin: 1,
            invalidateOnRefresh: true,
            onUpdate: function (self) {
              var i = $('.cine-pin-progress i', scene);
              if (i) i.style.transform = 'scaleX(' + self.progress + ')';
            }
          }
        });
        /* Acto A (0–0.8 ≈ progress 0–0.25): hero bottle → copy entra nítido */
        pinTl
          .to('.cine-pdp-media', { xPercent: 0, scale: 1, duration: 0.8, ease: 'none' }, 0)
          .to('.cine-pdp-media .pdp-main', { scale: 1, y: 0, duration: 0.8, ease: 'none' }, 0)
          .to('.cine-pdp-copy', { xPercent: 0, y: 0, duration: 0.8, ease: 'none' }, 0)
          .to('.cine-orb--p', { scale: 1.1, opacity: 0.9, duration: 0.8, ease: 'none' }, 0)
          /* Acto B (0.8–2.0 ≈ 0.25–0.62): layout morph */
          .to('.cine-pdp-media', { xPercent: -28, scale: 0.64, duration: 1.2, ease: 'none' }, 0.8)
          .to('.cine-pdp-media .pdp-main', { scale: 0.88, y: -36, rotate: -8, duration: 1.2, ease: 'none' }, 0.8)
          .to('.cine-pdp-copy', { xPercent: 0, y: -24, duration: 1.2, ease: 'none' }, 0.8)
          .to('.cine-orb--p', { scale: 2.05, x: 140, opacity: 1, duration: 1.2, ease: 'none' }, 0.8)
          /* Acto C (2.0–3.2 ≈ 0.62–1): bridge descripción */
          .to('.cine-pdp-media', { y: -110, opacity: 0.28, scale: 0.55, duration: 1.2, ease: 'none' }, 2.0)
          .to('.cine-pdp-copy', { y: -130, opacity: 0.18, duration: 1.2, ease: 'none' }, 2.0)
          .to('.cine-orb--p', { scale: 2.4, opacity: 0.3, duration: 1.2, ease: 'none' }, 2.0);
        window.__nmPdpPin = pinTl.scrollTrigger;
      } else if (scene && isMobile()) {
        gsap.to('.cine-pdp-media .pdp-main', {
          y: -36, scale: 0.94, ease: 'none',
          scrollTrigger: { trigger: scene, start: 'top top', end: 'bottom top', scrub: 1 }
        });
      }

      $$('.pdp-details, .cine-related').forEach(function (sec) {
        if (!sec || reduce) return;
        gsap.from(sec.querySelectorAll('.pdp-h2, .pdp-desc-shell, .cine-track--rel .card'), {
          opacity: 0, y: 32, duration: 0.8, ease: 'expo.out', stagger: 0.05,
          scrollTrigger: { trigger: sec, start: 'top 85%', once: true }
        });
      });
    }

    var sky = $('#sky');
    if (sky && !document.body.classList.contains('tpl-index')) {
      ScrollTrigger.create({
        start: 0, end: 'max',
        onUpdate: function (s) {
          sky.style.setProperty('--gx', (78 - s.progress * 40) + '%');
          sky.style.setProperty('--gy', (18 + s.progress * 35) + '%');
        }
      });
    }

    requestAnimationFrame(function () { ScrollTrigger.refresh(); });
    addEventListener('load', function () { ScrollTrigger.refresh(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
